// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2vKcL","choiceBoxes":"toolbarselects_choiceBoxes__oq3j4","simpleField":"toolbarselects_simpleField__3Y20L"};